export default __webpack_public_path__ + "static/skull_w.3ed32005fc764a4ad136da2393430413.png";